<div class="flex flex-col min-h-screen">
    <!-- Header Desktop -->
    <div class="hidden md:block">
        <pax-header [showNavigation]="!isPublicRoute" [navigationItems]="navigationItems"></pax-header>
    </div>

    <!-- Header Mobile -->
    <div class="block md:hidden">
        <pax-header-mobile></pax-header-mobile>
    </div>

    <!-- Main Content -->
    <main class="flex-grow bg-background">
        <router-outlet />
    </main>

    <!-- Footer Desktop - Only visible on screens >= 768px (md breakpoint) -->
    <div class="hidden md:block">
        <pax-footer [lang]="lang()" [availableLanguages]="availableLanguages" [footerItems]="footerItems" (languageChange)="onLanguageChange($event)"></pax-footer>
    </div>

    <!-- Mobile Navigation - Replaces footer on screens < 768px -->
    @if (!isPublicRoute) {
        <div class="block md:hidden">
            <pax-bottom-navigation
                [navigationItems]="navigationItemsMobile"
                [moreLabel]="'navigation.more' | translate"
                [availableLanguages]="availableLanguages"
                [currentLang]="lang()"
                (languageChange)="onLanguageChangeMobile($event)"
            ></pax-bottom-navigation>
        </div>
    }

    <!-- Scroll to top - Hidden on mobile -->
    <div class="hidden md:block">
        <pax-scroll-to-top />
    </div>
</div>

<pax-cookie-banner />
<pax-toast-container />
